import moment from 'moment';

export const getYearRange = (creationDate: string) => {
  const years = [];
  let startYear = moment(creationDate).year();
  const currentYear = moment().year();

  while (startYear <= currentYear) {
    years.push(startYear++);
  }

  return years.map((v) => ({ name: `${v}` }));
};
